import { message } from 'antd';
import { getUploadFileUrls, uploadImageToS3 } from 'network/common.api';

export const MAX_FILES = 5;
export const MAX_FILE_SIZE_MB = 2;
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const validateImageFile = (file: any): boolean => {
    const isValidType = ALLOWED_IMAGE_TYPES.includes(file.type);
    const isValidSize = file.size / 1024 / 1024 < MAX_FILE_SIZE_MB;

    if (!isValidType) {
        message.error('Only JPG, JPEG, and PNG files are allowed!');
        return false;
    }

    if (!isValidSize) {
        message.error(`File must be smaller than ${MAX_FILE_SIZE_MB}MB!`);
        return false;
    }

    return true;
};

export const uploadImagesToS3 = async (fileList: any[]): Promise<string[]> => {
    if (!Array.isArray(fileList) || fileList.length === 0) {
        return [];
    }

    const uploadPromises = fileList.map(async (file: any) => {
        const bodyGetUrl = { content_type: file?.type };
        const response = await getUploadFileUrls(bodyGetUrl);
        const upload = await uploadImageToS3(
            new Blob([file?.originFileObj as BlobPart], { type: file?.type }),
            response?.data?.result?.imageSignedUrl,
            file?.type,
        );
        return upload?.isSuccess ? response?.data?.result?.imageUrl : null;
    });

    const uploadedUrls = await Promise.all(uploadPromises);
    const validUrls = uploadedUrls.filter((url: any) => url !== null);

    if (uploadedUrls.length > 0 && validUrls.length === 0) {
        throw new Error('Failed to upload images');
    }

    return validUrls;
};
